module.exports = __webpack_public_path__ + "img/template-07.12d5e147.jpg";